<template>
    <section class="about__banner__container" v-if="fields">
        <img class="bg"
            v-if="isImage" 
            v-simple-parallax="{ scale: 1.1, delay: 0.4 }" 
            :src="fullPath" 
            alt=""
        >
        <video class="bg"
            v-else-if="isVideo" 
            :src="fullPath" 
            autoplay 
            loop 
            muted 
            playsinline
        ></video>
        <div class="parent">
            <div :class="`div${index + 1}`" v-for="(item, index) in fields['Banner images']"><img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="Image 1"></div>
            <div class="div6">
                <div class="title">{{ fields['Banner title'] }}</div>
                <ButtonOrange style="width: 225px;" @click="this.$scrollTo('footer');">{{ fields['Text Button'] }}</ButtonOrange>
            </div>
            <div class="div7"> </div>
        </div>
    </section>
</template>

<script>
import ButtonOrange from '../UI/ButtonOrange.vue';
    export default {
        components: {
            ButtonOrange,
        },
        props: {
          fields: [Array,Object],
        },
        computed: {
            fullPath() {
                return `${this.$store.state.base_directory}${this.fields['Banner mobile image'].replace(/^public\//, '')}`;
            },
            isImage() {
                return /\.(jpg|jpeg|png|gif|webp)$/i.test(this.fields['Banner mobile image']);
            },
            isVideo() {
                return /\.(mp4|webm|ogg)$/i.test(this.fields['Banner mobile image']);
            }
        },
    }
</script>

<style scoped>
.about__banner__container{
    margin-top: 150px;
}
.parent {
display: grid;
grid-template-columns: repeat(7, 1fr);
grid-template-rows: repeat(3, 1fr);
grid-column-gap: 32px;
grid-row-gap: 32px;
max-height: 480px;
width: 100%;
}

.div1 { grid-area: 1 / 1 / 4 / 2; max-height: 479px; }
.div2 { grid-area: 2 / 2 / 4 / 3; max-height: 269px; }
.div3 { grid-area: 3 / 3 / 4 / 6; max-height: 171px; }
.div4 { grid-area: 2 / 6 / 4 / 7; max-height: 269px; }
.div5 { grid-area: 1 / 7 / 4 / 8; max-height: 479px; }
.div6 { 
    grid-area: 1 / 2 / 2 / 7; 
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;
}
.div6 .title{
    /* Header/H1: 44px Medium */
    color: rgb(5, 5, 5);
    font-size: 44px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
.div7 { grid-area: 2 / 3 / 3 / 6; }
img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}
.bg{
    display: none;
}
@media (max-width: 1024px) {
    .div6 .title{
        font-size: 32px;
    }
}
@media (max-width: 768px) {
    .div1,.div2,.div3,.div4,.div5,.div7{
    display: none;
    }
    .div6{
        grid-area: 1 / 1 / -1 / -1;
        padding: 0 16px;
    }
    .div6 .title{
        font-size: 24px;
        color: white;
    }
    .about__banner__container {
        margin-top: unset;
        padding-top: 70% !important;
        position: relative;
    }
    .parent{
        position: absolute;
        top: 50%;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translateY(-50%);
        z-index: 2;
    }
    .bg{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        object-fit: cover;
    }
}
</style>